import { ChangePayload } from "./useSearchChangesetChanges.query";

const FIELD_ORDER = [
    'eeContributionAmount',
    'erContributionAmount', 
    'contributionDateOn',
    'taxYear',
    'taxType',
    'memo'
  ];
export const sortByFieldName = (a: ChangePayload, b: ChangePayload) => {
  const aFieldName = a.field_name || '';
  const bFieldName = b.field_name || '';
  
  const aIndex = FIELD_ORDER.findIndex(field => aFieldName.toLowerCase().includes(field.toLowerCase()));
  const bIndex = FIELD_ORDER.findIndex(field => bFieldName.toLowerCase().includes(field.toLowerCase()));
  
  if (aIndex !== -1 && bIndex !== -1) {
    return aIndex - bIndex;
  }
  
  if (aIndex !== -1) return -1;
  if (bIndex !== -1) return 1;
  
  return aFieldName.localeCompare(bFieldName);
};
